<div class="not-found-container">
  <div class="not-found-title" data-content="404">
    404
  </div>

  <div class="not-found-subtitle">
    Oops, the page you're looking for doesn't exist.
  </div>

  <div class="not-found-buttons" *ngIf="!ssoEnabled || !msalEnabled">
    <a class="not-found-button" (click)=navigateToHome()>Go to Home</a>
  </div>
</div>